/**
 * UseCaseSortOffers class implements the iUseCaseSortOffers interface and provides methods for sorting offers.
 */
import { GroupRates } from "../../domain/constants";
import { getLandingPageBrand } from "../../presentation/hooks/LandingPage";
/**
 * Represents a class that implements the iUseCaseSortOffers interface to handle sorting of offers based on specific criteria.
 */
export default class UseCaseSortOffers {
    /**
     * Handles the sorting of offers based on specific criteria.
     * @param data - Array of offers to be sorted.
     * @returns Returns an array of sorted offers based on the provided criteria.
     */
    handle(data) {
        // Retrieve the Landing Page Renter Code
        const LandingPageRenterCode = getLandingPageBrand();
        // If a valid Landing Page Renter Code is available
        if (LandingPageRenterCode !== "" && LandingPageRenterCode !== undefined) {
            // Group offers by brand code
            const dataGroup = this.groupByBrand(data, LandingPageRenterCode);
            // Sort and combine offers from renter and other categories
            let result = dataGroup.renter.sort((a, b) => this.sortByTotal(a, b));
            result.push(...dataGroup.other.sort((a, b) => this.sortByTotal(a, b)));
            return result; // Return the sorted array of offers
        }
        // If no Landing Page Renter Code is found, sort all offers and return the result
        let result = [];
        let orderData = data.sort((a, b) => this.sortByTotal(a, b));
        return orderData;
    }
    /**
     * Groups offers by brand into 'renter' and 'other' categories.
     * @param data - Array of offers to be grouped.
     * @param landingPageRenterCode - The brand code for grouping.
     * @returns An object containing grouped offers under 'renter' and 'other' categories.
     */
    groupByBrand(data, landingPageRenterCode) {
        let groupedData = { renter: [], other: [] };
        for (const car of data) {
            if (car.renter.renterCode === landingPageRenterCode)
                groupedData.renter.push(car);
            else
                groupedData.other.push(car);
        }
        return groupedData;
    }
    /**
     * Compares two offers based on their total currency amount.
     * @param a - First offer to compare.
     * @param b - Second offer to compare.
     * @returns A number representing the comparison result.
     */
    sortByTotal(a, b) {
        const diff = a.pricesDetail.currency[0].total.baseAmount -
            b.pricesDetail.currency[0].total.baseAmount;
        if (diff > 0)
            return 1;
        else if (diff < 0)
            return -1;
        else
            return 0;
    }
    /// <summary>
    /// Sort the offers based on group rate and add the next result to the item tha have the lowest price and group rate all inclusive
    /// </summary>
    /// <param name="dataSorted">The sorted data</param>
    sortByGroupRate(dataSorted) {
        let result = [];
        // Group the data by renter, sipp code and price
        let groupdata = Object.values(dataSorted.reduce((acc, car) => {
            const key = `${car.renter.renterCode}-${car.car.sippCode}-${car.car.name}`;
            if (!acc[key] || (car.renter.renterCode === acc[key].renter.renterCode &&
                car.car.sippCode === acc[key].car.sippCode &&
                car.pricesDetail.currency[0].total.baseAmount < acc[key].pricesDetail.currency[0].total.baseAmount)) {
                acc[key] = car;
            }
            return acc;
        }, {}));
        ///seach the next item with the same renter, sipp code and price and andd nexto to the result
        groupdata.map((offer) => {
            result.push(offer);
            if (offer.renter.rateQualifier[0].groupRate === GroupRates.BASIC_PLUS) {
                var offerNext = dataSorted.filter((item) => item.pricesDetail.currency[0].total.baseAmount > offer.pricesDetail.currency[0].total.baseAmount &&
                    item.renter.renterCode === offer.renter.renterCode &&
                    item.car.sippCode === offer.car.sippCode);
                if (offerNext.length > 0) {
                    result.push(offerNext[0]);
                }
            }
        });
        return result;
    }
}
